const tokensHR = {
    "view": {
        "title": "Povijest tokena",
        "table": {
            "column": {
                "quantity": "Kolicina",
                "description": "Opis",
                "type": "Vrsta",
                "balance": "Stanje",
                "date": "Datum",
                "receipt": "Potvrda"
            },
            "placeholder": {
                "search": "Pretrazi..."
            },
            "button": {
                "view": "Pregledaj",
                "export_csv": "Izvezi CSV",
                "order_tokens": "Naruci tokene"
            },
            "label": {
                "not_available": "Nije dostupno",
                "credit": "Kredit",
                "debit": "Dugovanje"
            }
        }
    },
    "order": {
        "title": "Naruci tokene",
        "form": {
            "label": {
                "quantity": "Kolicina"
            },
            "placeholder": {
                "quantity": "Odaberite kolicinu"
            },
            "help": {
                "quantity": "Broj tokena koji zelite naruciti."
            },
            "validation": {
                "quantityRequired": "Kolicina je obavezna"
            },
            "button": {
                "placeOrder": "Naruci"
            },
            "option": {
                "tokensAmount": "{{count}} tokena"
            }
        },
        "modal": {
            "title": "Nastavi na naplatu",
            "orderedPrefix": "Narucili ste",
            "description": "Ako zelite potvrditi narudzbu, nastavite na naplatu. U suprotnom, mozete otkazati narudzbu.",
            "button": {
                "cancel": "Otkazi",
                "checkout": "Naplata"
            }
        },
        "message": {
            "error": "Nesto je poslo po zlu! Osvjezite stranicu i pokusajte ponovno!"
        }
    },
    "transaction": {
        "success": {
            "title": "Transakcija uspjesna :)",
            "description": "Uspjesno ste kupili tokene koji ce uskoro biti dodani na vas racun!"
        },
        "cancel": {
            "title": "Transakcija otkazana :(",
            "description": "Transakcija je otkazana... Pokusajte ponovno kasnije!"
        },
        "button": {
            "returnToDashboard": "Povratak na nadzornu plocu"
        }
    }
};

export default tokensHR;
